import React, { useState } from 'react';
import cx from 'classnames';
import { Skeleton, Row, Col } from 'antd';
import { isNil } from 'lodash';

import barChartImg from 'assets/img/stats.png';
import barChartActiveImg from 'assets/img/stats-active.png';
import pieChartImg from 'assets/img/disabledPieChartDshTab.svg';
import pieChartActiveImg from 'assets/img/pieChartDshTab.svg';

import styles from './DashboardTab.module.less';

export enum ChartImageType {
  PieChart,
  BarChart,
}

type Props = {
  title: string;
  isActive: boolean;
  loading?: boolean;
  onClick: () => void;
  detailsSubTitle?: string;
  detailsTitle?: string | number;
  chartImageType?: ChartImageType;
};

const getChartImage = (
  chartImageType: ChartImageType,
  isHighlighted: boolean,
) => {
  switch (chartImageType) {
    case ChartImageType.PieChart:
      return isHighlighted ? pieChartActiveImg : pieChartImg;

    case ChartImageType.BarChart:
    default:
      return isHighlighted ? barChartActiveImg : barChartImg;
  }
};

export default function DashboardTab(props: Props) {
  const {
    title,
    detailsTitle,
    detailsSubTitle,
    isActive,
    loading,
    onClick,
    chartImageType = ChartImageType.BarChart,
  } = props;
  const [isTabHovered, setIsTabHovered] = useState(false);
  const isTabHighlighted = isActive || isTabHovered;
  const chartImage = getChartImage(chartImageType, isTabHighlighted);

  return (
    <div
      className={cx(styles.tab, {
        [styles.active]: isTabHighlighted,
      })}
      onClick={onClick}
      onMouseEnter={() => setIsTabHovered(true)}
      onMouseLeave={() => setIsTabHovered(false)}
    >
      <div className={styles.chartWrapper}>
        <Row gutter={[2, 2]}>
          <Col flex="auto">
            {loading && (
              <div>
                <Skeleton active paragraph={{ rows: 1 }} />
              </div>
            )}
            {!loading && (
              <>
                {!isNil(detailsTitle) && (
                  <div className={styles.detailsTitle}>{detailsTitle}</div>
                )}
                {detailsSubTitle && (
                  <div className={styles.detailsSubTitle}>
                    {detailsSubTitle}
                  </div>
                )}
              </>
            )}
          </Col>

          <Col flex="none">
            <img alt="" src={chartImage} className={styles.chart} />
          </Col>
        </Row>
      </div>

      <div className={styles.title}>{title}</div>
    </div>
  );
}
